<template>
  <v-container fluid>
    <!-- CONTENTS -->
    <v-row class="pa-2">
      <v-col>
        <v-sheet>
          <v-col>
            <v-tabs grow>
              <v-tab
                v-for="(section, i) in sections"
                :key="i"
              >
                {{ $t(section.text) }}
              </v-tab>
              <v-tab-item>
                <user-section />
              </v-tab-item>
              <v-tab-item>
                <edit-user-section />
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import userSection from "./TohruPage/UserSection.vue";
import editUserSection from "./TohruPage/EditUserSection";

// Libs
const md5 = require("md5");

export default {
  components: {
    userSection,
    editUserSection,
  },
  data() {
    return {
      sections: [
        {
          text: "akito.add",
        },
        {
          text: "akito.edit",
        },
      ],
    };
  },
  created() {
    document.title = this.$t("akito.user") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("akito.user"));
  },
  mounted() {
    // ADMIN CHECKING
    if (md5(this.$store.state.user.aikido) != "bc4634dcd9303d59bace805e02472bcd") {
      this.$store.dispatch("disconnect");

      if (this.$router.history.current.fullPath != "/") {
        this.$router.push({ path: "/" });
      }
    }
  },
};
</script>

<style></style>
